// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSchedulerByReferentsRequestModel from '../../model/get-scheduler-by-referents-request-model';
import GetSchedulerByReferentsRequestDTO from '../dto/get-scheduler-by-referents-request-dto';
import dtoSchema from '../schemas/get-scheduler-by-referents-request-schema';

export default abstract class GetSchedulerByReferentsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSchedulerByReferentsRequestDTO>) {
    super();
    if (data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      this.selectedResourceTypes = data.selectedResourceTypes;
    }
  }
  /**
  * @type {date-time}
  */
  startTime?: string;
  /**
  * @type {date-time}
  */
  endTime?: string;
  /**
  */
  selectedResourceTypes?: number[];

  static toModel(dto: DeepPartial<GetSchedulerByReferentsRequestDTO>): GetSchedulerByReferentsRequestModel;
  static toModel(dto: DeepPartial<GetSchedulerByReferentsRequestDTO> | undefined | null): GetSchedulerByReferentsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSchedulerByReferentsRequestDTO> | undefined | null): GetSchedulerByReferentsRequestModel | undefined {
    return dto ? new GetSchedulerByReferentsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSchedulerByReferentsRequestModel> | GetSchedulerByReferentsRequestModel): GetSchedulerByReferentsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      startTime: unwrapped.startTime,
      endTime: unwrapped.endTime,
      selectedResourceTypes: unwrapped.selectedResourceTypes,
    } as GetSchedulerByReferentsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSchedulerByReferentsRequestModel, can not map to GetSchedulerByReferentsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
